/** src/index.js
 *  This is the main entry point for all views
 *  The file that handles the content being shown is ./routes/AppRouter.js
 *  The ./routes directory holds all of the page routes in different files, 
 *  and will display a page/view component for each route. * 
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './routes/AppRouter';
import * as serviceWorker from './serviceWorker';
import { PROJECT_NAME } from './config';

ReactDOM.render(
    <AppRouter /> ,
  document.getElementById('root'));

// Load CSS file based on the project version and attach it to the document
const loadCSS = (theme) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `/themes/theme-${theme}.css`;
    link.onload = () => resolve();
    link.onerror = () => reject(`Unable to load the theme ${theme}`);
    document.head.appendChild(link);
  });
};

// Set the document title and favicon based on the version

const favicon = document.querySelector("link[rel='icon']");
if (favicon) {
  favicon.href = `/${PROJECT_NAME}-favicon.ico`;
}

loadCSS(PROJECT_NAME).then(() => {
  ReactDOM.render(
    <AppRouter /> ,
    document.getElementById("root")
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
